import React from 'react';
import {StyleSheet, View} from 'react-native';

import theme from '../../style/theme';
import Button from '../ui-controls/Button';
import CrossPlatformModal from '../ui-controls/CrossPlatformModal';

const CheckoutLogInModal = ({isVisible, onPress}: {isVisible: boolean; onPress: () => void}) => (
  <View>
    <CrossPlatformModal
      isVisible={isVisible}
      style={styles.main}
      hasBackdrop={true}
      backdropColor="black"
      backdropOpacity={0.56}
      animationIn="slideInUp"
      onBackButtonPress={() => {}}>
      <View style={styles.view}>
        <Button
          onPress={onPress}
          title="TO PLACE AN ORDER LOG IN OR CREATE AN ACCOUNT"
          titleStyle={styles.buttonText}
          buttonStyle={styles.button}
        />
      </View>
    </CrossPlatformModal>
  </View>
);

const styles = StyleSheet.create({
  main: {
    width: '100%',
    marginLeft: 0,
    justifyContent: 'flex-end',
    marginBottom: 0,
  },
  view: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 36,
    alignItems: 'center',
  },
  text: {
    fontSize: 16,
    marginBottom: 32,
    textAlign: 'center',
    color: theme.colour.text.heading.primary,
  },
  button: {
    width: 250,
  },
  buttonText: {
    fontSize: 16,
  },
});

export default CheckoutLogInModal;
